<script setup lang="ts">
import { currentYear } from '@/utils/temporal-helper';
import { FOOTER_LINK_LIST } from '@/constants/links';
</script>

<template>
  <footer>
    <div class="container flex-between">
      <div class="logo-block">
        <img
          class="logo"
          src="/icons/lesta-logo.svg"
          alt="lesta-logo"
          loading="lazy"
        />

        <div class="description">
          <p>
            Игра &laquo;Мир кораблей&raquo; основана на&nbsp;интеллектуальной собственности третьих
            лиц. Все права на&nbsp;объекты прав третьих лиц принадлежат их&nbsp;законным
            правообладателям.
          </p>
          <p>&copy;&nbsp;Леста Игры, 2022 &mdash; {{ currentYear }}</p>
          <span class="g-icon-fill is-hidden">check_circle</span>
        </div>
      </div>

      <div class="link-list">
        <a
          v-for="(item, key) in FOOTER_LINK_LIST"
          :key="key"
          :href="item.link"
          class="link"
          target="_blank"
          >{{ item.name }}</a
        >

        <nuxt-link
          to="/guide"
          class="link"
          >Как загрузить реплей
        </nuxt-link>
      </div>
    </div>
  </footer>
</template>

<style scoped lang="postcss">
footer {
  margin-top: var(--space-xl-var_01);
  color: var(--color-white-50);

  & .container {
    padding: 40px 0 8px;
    position: relative;
    border-top: 1px solid var(--color-white-12);
  }
}

.description {
  gap: var(--space-s-var_01);
  display: flex;
  flex-direction: column;
  max-width: 560px;
  text-wrap: pretty;

  @media (--lg-desktop) {
    max-width: 710px;
  }
}

.logo-block {
  display: grid;
  grid-template-columns: 146px auto;
  grid-gap: var(--space-m-var_02);

  .logo {
    position: relative;
    top: -8px;
    width: 100%;
  }
}

.link-list {
  display: grid;
  gap: 0 56px;
  grid-template: auto / 1fr auto;
  align-items: flex-start;
}
</style>
